import React from 'react'
import Grade from '../grade'
import isStudent from '../../../utilities/is-student'

const ProfileName = ({ user }) => {
    if (!isStudent(user)) {
        return null
    }
    return (
        <div style={{
            fontWeight: '500'
        }}>
            Grade: <Grade user={user} mode={Grade.modes.TITLE} />
        </div>
    )
}

export default ProfileName